import React from "react";

import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import Stack, { Column, Row, StackProps } from "@rui/Stack";
import TooltipIcon from "@rui/TooltipIcon";

export const ContentContainer = styled(Column)(({ theme }) => ({
  padding: theme.spaces.large,
  paddingTop: theme.spaces.base,
  paddingBottom: theme.spaces.xsmall,
}));

export const SettingSection = styled(Column)(({ theme }) => ({
  borderTop: "1px solid",
  borderColor: theme.palette.shades.neutral[50],
  padding: theme.spacing(1, 0, 1.5),
}));

export const SettingRow = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  rowGap: theme.spacing(1.5),

  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
    columnGap: theme.spacing(3),
    alignItems: "center",
    justifyContent: "space-between",
  },
}));

export const CategoryLabel = styled(Typography)(({ theme }) => ({
  ...theme.typography.labelMed,
  color: theme.palette.shades.primary[500],
}));

const SettingLabel = styled(Typography)(({ theme }) => ({
  ...theme.typography.bodySecondaryMed,
  color: theme.palette.shades.neutral[800],
}));

type SettingProps = StackProps & { label: string; tooltip: string };

export const Setting = styled<React.FC<SettingProps>>(
  ({ label, tooltip, children, ...props }) => (
    <Column {...props} spacing={1}>
      <Row variant="left" spacing={1}>
        <SettingLabel>{label}</SettingLabel>
        <TooltipIcon title={tooltip} variant="help" placement="bottom" />
      </Row>
      {children}
    </Column>
  )
)(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    flexBasis: "calc(50% - 12px)", // 12px = 1/2 of spacing between dropdowns
  },
}));

export const Footer = styled(Row)(({ theme }) => ({
  padding: theme.spacing(2, 3),
}));
